// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add / update client dialogs */
.AddClients .addBtn,
.UpdateClient .addBtn {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2);
}

.AddClients button,
.UpdateClient button {
  cursor: pointer;
}

.UpdateClient .upload-btn {
  border: 0;
  background: none;
  color: inherit;
}

/* Clients list + grid view */
.clients-page .clients-grid__card {
  height: 100%;
  text-align: center;
}

.clients-page .clients-grid__cover {
  position: relative;
  display: flex;
  justify-content: center;
  padding: var(--ds-space-5) var(--ds-space-4) var(--ds-space-2);
}

.clients-page .clients-grid__menu {
  position: absolute;
  inset-block-start: var(--ds-space-2);
  inset-inline-end: var(--ds-space-2);
}

.clients-page .clients-grid__text {
  overflow-wrap: anywhere;
}

.clients-page .clients-grid__actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--ds-space-2);
  margin-block-start: var(--ds-space-4);
}

.clients-page .clients-grid__actions .ant-btn {
  flex: 1 1 auto;
  min-height: 40px;
}
`, "",{"version":3,"sources":["webpack://./src/serviceProvider/components/clients/Clients.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;;EAEE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,8DAA8D;AAChE;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB","sourcesContent":["/* Add / update client dialogs */\n.AddClients .addBtn,\n.UpdateClient .addBtn {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n}\n\n.AddClients button,\n.UpdateClient button {\n  cursor: pointer;\n}\n\n.UpdateClient .upload-btn {\n  border: 0;\n  background: none;\n  color: inherit;\n}\n\n/* Clients list + grid view */\n.clients-page .clients-grid__card {\n  height: 100%;\n  text-align: center;\n}\n\n.clients-page .clients-grid__cover {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  padding: var(--ds-space-5) var(--ds-space-4) var(--ds-space-2);\n}\n\n.clients-page .clients-grid__menu {\n  position: absolute;\n  inset-block-start: var(--ds-space-2);\n  inset-inline-end: var(--ds-space-2);\n}\n\n.clients-page .clients-grid__text {\n  overflow-wrap: anywhere;\n}\n\n.clients-page .clients-grid__actions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: var(--ds-space-2);\n  margin-block-start: var(--ds-space-4);\n}\n\n.clients-page .clients-grid__actions .ant-btn {\n  flex: 1 1 auto;\n  min-height: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
